<p-toast key="custom-toast" position="top-right" [baseZIndex]="5000">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div
      class="flex items-center justify-between rounded-md shadow-md px-4 py-3 min-h-12"
      [ngClass]="{
        'bg-success-50 border border-success-600':
          message.severity === 'success',
        'bg-error-50 border border-error-600': message.severity === 'error',
        'bg-warning-50 border border-warning-600': message.severity === 'warn',
        'bg-info-50 border border-info-600': message.severity === 'info'
      }"
    >
      <div class="flex items-center gap-3">
        <span
          class="flex items-center justify-center h-8 w-8 rounded-full"
          [ngClass]="{
            'bg-success-600 text-white': message.severity === 'success',
            'bg-error-600 text-white': message.severity === 'error',
            'bg-warning-600 text-white': message.severity === 'warn',
            'bg-info-600 text-white': message.severity === 'info'
          }"
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-check': message.severity === 'success',
              'pi-times': message.severity === 'error',
              'pi-exclamation-triangle': message.severity === 'warn',
              'pi-info-circle': message.severity === 'info'
            }"
            style="font-size: 1.2rem"
          ></i>
        </span>
        <div>
          <span class="font-semibold text-base">{{ message.summary }}</span>
          <div *ngIf="message.detail" class="text-sm mt-1 text-gray-700">
            <span *ngFor="let detail of message.detail.split('|')"
              >{{ detail }}<br
            /></span>
          </div>
        </div>
      </div>
      <button
        type="button"
        (click)="close()"
        class="ml-4 text-gray-500 hover:text-gray-700"
      >
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>
  </ng-template>
</p-toast>
